import { render } from "./SeniorityCard.vue?vue&type=template&id=89e31120&scoped=true"
import script from "./SeniorityCard.vue?vue&type=script&lang=js"
export * from "./SeniorityCard.vue?vue&type=script&lang=js"

import "./SeniorityCard.vue?vue&type=style&index=0&id=89e31120&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89e31120"]])

export default __exports__